import {
  ISearchPac,
  IStandardAPIResponse,
  IPACReading,
  IReadingStatus,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getPacReadings(
  obj: ISearchPac
): Promise<IStandardAPIResponse<Array<IPACReading>>> {
  try {
    let res = await httpClient<Array<IPACReading>>(`pac-reading`, "GET", obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function updatePacReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`pac-reading/status`, "PATCH", obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updatePacReading(
  data: IPACReading
): Promise<IStandardAPIResponse<IPACReading>> {
  try {
    let res = await httpClient<IPACReading>(
      `pac-reading/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
